import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { routes } from '../../router';

import Dashboard from '../dashboard';
import DashboardWidgetObjects from '../widgetObjectsDashboard';
import IntegrationDetails from '../integration-details';
import { FontUpgrade, Modal } from 'wix-style-react';

class Router extends Component {
  static propTypes = {
    view: PropTypes.object.isRequired,
    integrations: PropTypes.object.isRequired,
    basename: PropTypes.string.isRequired,
  };

  renderModal = () => {
    const {
      view: { openedModal, closeModal: handleRequestClose },
    } = this.props;

    return (
      <Modal
        contentLabel="Modal"
        isOpen={!!openedModal}
        onRequestClose={handleRequestClose}
        scrollableContent={false}
      >
        {openedModal}
      </Modal>
    );
  };

  renderIntegrationDetails = ({
    match: {
      params: { type },
    },
  }) => <IntegrationDetails type={type} />;

  render() {
    const { appConfig } = this.props;
    const dashBoardComponent =
      appConfig.experiments['specs.promote.mi.ui.marketingIntegrationTPAs'] ===
      'true'
        ? DashboardWidgetObjects
        : Dashboard;
    return (
      <FontUpgrade
        active={
          appConfig.experiments['specs.promote.mi.ui.FontUpgrade'] === 'true'
        }
      >
        {this.renderModal()}
        <Switch>
          <Route exact path={routes.DASHBOARD} component={dashBoardComponent} />
          <Route
            path={routes.WIDGET_DETAILS}
            render={this.renderIntegrationDetails}
          />
          <Redirect path={routes.ANY} to={routes.DASHBOARD} />
        </Switch>
      </FontUpgrade>
    );
  }
}

export default inject(
  'appConfig',
  'integrations',
  'view',
)(withRouter(observer(Router)));
